export let Tgp20_1_64 = {
	"name": "Tgp20_1_64",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Внутренние функции государства",
	"data": {
		"questions": [
			{
				"qst": "К внутренним функциям государства относятся...",
				"correct_ans": [
					{
						"comm": "Да, действительно, гуманитарные науки изучают объекты и процессы, происходящие в человеческом обществе. Поэтому теория государства относится к гуманитарным наукам.",
						"ans": "Гуманитарные науки",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"comm": "Естественные науки изучают природные объекты и процессы. По общему мнению, государство не принадлежит к их числу.",
						"ans": "Естественные науки",
						"score": 0
					},
					{
						"comm": "Технические науки изучают объекты и процессы, происходящие в мире техники, т. е. созданной человеком \"второй природы\" (Б. Спиноза). Поскольку явление государства не принадлежит к технике, теорию государства не относят к области технических наук.",
						"ans": "Технические науки",
						"score": 0
					},
					{
						"comm": "Традиционно термин \"точные науки\" используется по отношению к математике и наукам, интенсивно использующим математические методы. Теория государства к таким наукам не относится.",
						"ans": "Точные науки",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Верно ли, что естественные науки изучают объекты и процессы, происходящие в человеческом обществе?",
				"right_ans": [
					{
						"ans": "Нет",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "Да",
						"score": 0
					}
				],
				"comm": "Постарайтесь вспомнить известные Вам естественные науки"
			}
		]
	},
	"minigameType": "Question",
	"comm": "Правильный ответ на вопрос позволяет установить место теории государства в системе юридических наук"
}

export let Tgp20_1_2 = {
	"name": "Tgp20_1_2",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Теория двух мечей",
	"data": {
		"questions": [
			{
				"qst": "Теория происхождения государства, известная как теория \"двух мечей\", представляет из себя...",
				"correct_ans": [
					{
						"ans": "теологическую теорию",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "теорию насилия",
						"score": 0
					},
					{
						"ans": "договорную теорию",
						"score": 0
					},
					{
						"ans": "органическую теорию",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Верно ли, что теория \"двух мечей\" уподобляет двум мечам внешние и внутренние функции государства?",
				"right_ans": [
					{
						"ans": "Нет",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "Да",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Плюрализм точек зрения по вопросу происхождения государства объясняется, в частности, разнообразием конкретно-исторических условий образования государств, отдаленностью и длительностью этих процессов, а также отсутствием ясных и достаточных документальных данных"
}

export let Tgp20_1_3 = {
	"name": "Tgp20_1_3",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Теория государства",
	"data": {
		"questions": [
			{
				"qst": "Теория происхождения государства, известная как теория \"двух мечей\", уподобляет двум мечам ...",
				"correct_ans": [
					{
						"ans": "духовную и светскую власть",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "государство и право",
						"score": 0
					},
					{
						"ans": "внешние и внутренние функции государства",
						"score": 0
					},
					{
						"ans": "исполнительную и законодательную власть",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Верно ли, что теория \"двух мечей\" сопоставляет двум мечам исполнительную и законодательную власть?",
				"right_ans": [
					{
						"ans": "Нет",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "Да",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Теория \"двух мечей\" исходит из того, что основатели церкви имели два меча. Один они вложили в ножны и оставили при себе. Ибо не пристало церкви самой использовать меч. А второй они вручили государям для того, чтобы они могли вершить земные дела. Государь, по мнению богословов, наделяется церковью правом повелевать людьми и является слугой церкви. Основной смысл данной теории в том, чтобы утвердить приоритет духовной организации (церкви) над светской (государством) и доказать, что нет государства и власти \"не от бога\""
}

export let Tgp20_1_4 = {
	"name": "Tgp20_1_4",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Азиатский тип государства",
	"data": {
		"questions": [
			{
				"qst": "В рамках какой типологии государств выделяется \"азиатский\" тип государства?",
				"correct_ans": [
					{
						"comm": "Действительно, азиатский тип государства, соответствующий азиатскому способу производства, выделялся некоторыми учеными в рамках формационного подхода.",
						"ans": "Формационная",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"comm": "В рамках географической типологии государств, предложенной Жаном Боденом, ученый выделял южные, средние и северные государства. Специально азиатского типа государства не выделялось.",
						"ans": "Географическая",
						"score": 0
					},
					{
						"comm": "В рамках цивилизационной методологии специально азиатского типа государства не выделялось, хотя и рассматривались различные азиатские цивилизации.",
						"ans": "Цивилизационная",
						"score": 0
					},
					{
						"comm": "На самом деле азиатский тип государства выдвигался в рамках одного из трех основных подходов (географического, формационного, цивилизационного) к проблеме типологии государств.",
						"ans": "Ни одна из перечисленных",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Правда ли, что азиатский тип государства рассматривается в рамках цивилизационного подхода к типологии государств?",
				"right_ans": [
					{
						"ans": "Нет",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "Да",
						"score": 0
					}
				],
				"comm": "Это один из спорных вопросов типологии государства"
			}
		]
	},
	"minigameType": "Question",
	"comm": "В научной литературе предлагалось множество подходов к проблеме типологии государств, самыми заметными среди которых явились географический, формационный и цивилизационный подходы"
}

export let Tgp20_1_5 = {
	"name": "Tgp20_1_5",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Методология теории государства и права",
	"data": {
		"questions": [
			{
				"qst": "Рассмотрение существующих государственно-правовых явлений не только под углом зрения настоящего их состояния, но и с позиций их прошлого и предполагаемого будущего, составляет...",
				"correct_ans": [
					{
						"ans": "принцип историзма",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"ans": "принцип всесторонности исследования",
						"score": 0
					},
					{
						"ans": "принцип комплексности",
						"score": 0
					},
					{
						"ans": "сравнительно-правовой метод",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Правда ли, что принцип всесторонности исследования рассматривает в качестве сторон государственно-правовых явлений, в частности, предпосылки их возникновения (прошлое), текущее состояние (настоящее), а также тенденции их развития (предполагаемое будущее)?",
				"right_ans": [
					{
						"ans": "Нет",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "Да",
						"score": 0
					}
				],
				"comm": "Взаимосвязь методологических принципов теории государства и права составляет один из ее вопросов, пограничных с философией"
			}
		]
	},
	"minigameType": "Question",
	"comm": "Для ответа на этот вопрос полезно перечислить методологические принципы теории государства и права"
}

export let Tgp20_1_6 = {
	"name": "Tgp20_1_6",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Теория государства",
	"data": {
		"questions": [
			{
				"qst": "Естественно-правовая теория происхождения государства и права иначе называется...",
				"correct_ans": [
					{
						"ans": "договорная теория",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"ans": "теория насилия",
						"score": 0
					},
					{
						"ans": "теологическая теория",
						"score": 0
					},
					{
						"ans": "органическая теория",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Правда ли, что теория происхождения государства и права, известная как \"теория насилия\" рассматривала насилие как естественное явление?",
				"right_ans": [
					{
						"ans": "Нет",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "Да",
						"score": 0
					}
				],
				"comm": "Вспомните основные положения теории насилия"
			}
		]
	},
	"minigameType": "Question",
	"comm": "Вспомните основные положения естественно-правовой теории"
}

export let Tgp20_1_7 = {
	"name": "Tgp20_1_7",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Утверждение естественно-правовой теории",
	"data": {
		"questions": [
			{
				"qst": "Естественно-правовая теория происхождения государства утверждает, что...",
				"correct_ans": [
					{
						"ans": "государство является результатом объединения людей на договорной основе",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"ans": "процесс возникновения и развития государства в известной мере аналогичен процессу сотворения мира",
						"score": 0
					},
					{
						"ans": "причина возникновения государства и права лежит в завоевании, порабощении одних племен другими",
						"score": 0
					},
					{
						"ans": "государство является результатом действия сил природы, создающей его наряду с обществом и отдельным человеком",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Правда ли, что естественно-правовая теория происхождения государства и права утверждает, что процесс возникновения и развития государства в известной мере аналогичен процессу сотворения мира?",
				"right_ans": [
					{
						"ans": "Нет",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "Да",
						"score": 0
					}
				],
				"comm": "Вспомните основные положения естественно-правовой теории"
			}
		]
	},
	"minigameType": "Question",
	"comm": "Вспомните основные положения естественно-правовой теории"
}

export let Tgp20_1_8 = {
	"name": "Tgp20_1_8",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Основоположник патриархальной теории",
	"data": {
		"questions": [
			{
				"qst": "Основоположником патриархальной теории происхождения государства и права является...",
				"correct_ans": [
					{
						"ans": "Аристотель",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"ans": "К. Каутский",
						"score": 0
					},
					{
						"ans": "Фома Аквинский",
						"score": 0
					},
					{
						"ans": "Джон Локк",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Правда ли, что патриархальная теория происхождения государства и права была одним из первых теоретических представлений по этому вопросу?",
				"right_ans": [
					{
						"ans": "Да",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "Нет",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Вспомните основные положения патриархальной теории"
}

export let Tgp20_1_9 = {
	"name": "Tgp20_1_9",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Утверждение патриархальной теории",
	"data": {
		"questions": [
			{
				"qst": "Патриархальная теория происхождения государства утверждает, что государство возникает...",
				"correct_ans": [
					{
						"ans": "в результате появления и разрастания семьи",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"ans": "в процессе перехода от матриархата к патриархату",
						"score": 0
					},
					{
						"ans": "в результате деятельности старейшин и вождей племен",
						"score": 0
					},
					{
						"ans": "под воздействием авторитета жрецов и других теологических иерархов",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Правда ли, что патриархальная теория происхождения государства и права возникла в результате развития формационных представлений об общественном развитии?",
				"right_ans": [
					{
						"ans": "Нет",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "Да",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Вспомните основные положения патриархальной теории"
}

export let Tgp20_1_10 = {
	"name": "Tgp20_1_10",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Утверждение договорной теории",
	"data": {
		"questions": [
			{
				"qst": "Договорная теория происхождения государства и права утверждает, что государство возникло...",
				"correct_ans": [
					{
						"ans": "в результате добровольного объединения людей на договорной основе",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"comm": "Категорический императив не имеет отношения к проблеме возникновения государства, он был предложен И. Кантом как этический принцип и использовался (в том числе) для обоснования права.",
						"ans": "в результате договора людей между собой, выраженного в категорическом императиве",
						"score": 0
					},
					{
						"comm": "Вы пытаетесь интерпретировать договорную теорию в терминах марксизма, но марксизм объяснял возникновение государства иначе.",
						"ans": "при переходе к соседской общине в результате договора военных и религиозных руководителей (вождей и жрецов) с целью эксплуатации рядовых общинников",
						"score": 0
					},
					{
						"comm": "Вы пытаетесь выводить возникновение государства из возникновения правовых феноменов, но это, по меньшей мере, не общепринятая точка зрения.",
						"ans": "при возникновении частной собственности с целью обеспечить выполнение договорных и иных обязательств",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Правда ли, что договорная теория происхождения государства и права утверждает, что государство возникло в результате добровольного объединения людей на договорной основе?",
				"right_ans": [
					{
						"ans": "Да",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "Нет",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Вспомните основные положения договорной теории"
}

export let Tgp20_1_11 = {
	"name": "Tgp20_1_11",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Утверждение теории насилия",
	"data": {
		"questions": [
			{
				"qst": "Теория насилия происхождения государства утверждает, что государство возникло...",
				"correct_ans": [
					{
						"ans": "в результате завоевания и порабощения одних племен другими, приводящему к появлению рабства",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"ans": "в результате перехода от охоты и собирательства к земледелию, которое рассматривается как насилие над природой",
						"score": 0
					},
					{
						"ans": "как аппарат насилия в интересах эксплуататорского меньшинства для подавления сопротивления эксплуатируемого большинства",
						"score": 0
					},
					{
						"ans": "в результате насильственного захвата власти военными вождями племени при поддержке общинников - воинов",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Правда ли, что теория насилия утверждает, что государство возникло как аппарат насилия в интересах эксплуататорского меньшинства для подавления сопротивления эксплуатируемого большинства?",
				"right_ans": [
					{
						"ans": "Нет",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "Да",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Вспомните основные положения теории насилия"
}

export let Tgp20_1_12 = {
	"name": "Tgp20_1_12",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "'Общественный договор' Руссо",
	"data": {
		"questions": [
			{
				"qst": "Когда вышла в свет работа Жан-Жака Руссо \"Об общественном договоре\", в которой была наиболее ярко выражена договорная теория происхождения государства?",
				"correct_ans": [
					{
						"ans": "1762",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"ans": "1540",
						"score": 0
					},
					{
						"ans": "1688",
						"score": 0
					},
					{
						"ans": "1794",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Кто из выдающихся деятелей русской культуры был современником Жан-Жака Руссо (родился всего на один год раньше)?",
				"correct_ans": [
					{
						"ans": "М.В. Ломоносов (1711 - 1765)",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "Летописец Нестор (XI - начало XII в.), автор \"Повести временных лет\"",
						"score": 0
					},
					{
						"ans": "А.С. Пушкин (1799 - 1837)",
						"score": 0
					},
					{
						"ans": "Л.Н. Толстой (1828 - 1910)",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Вспомните время появления договорной теории происхождения государства"
}

export let Tgp20_1_13 = {
	"name": "Tgp20_1_13",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Права народа по договорной теории",
	"data": {
		"questions": [
			{
				"qst": "Какие неотчуждаемые, естественные права имеет народ согласно теории общественного договора, изложенной Руссо в работе \"Об Общественном договоре\"?",
				"correct_ans": [
					{
						"ans": "Право издавать законы",
						"score": 1
					},
					{
						"comm": "Да, это так.",
						"ans": "социальная",
						"score": 1
					},
					{
						"ans": "развития образования, науки и культуры",
						"score": 1
					},
					{
						"comm": "Да, это так.",
						"ans": "налогообложения и взимания налогов",
						"score": 1
					},
					{
						"ans": "экологическая",
						"score": 1
					},
					{
						"ans": "охраны прав и свобод граждан",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "обороны страны",
						"score": 0
					},
					{
						"ans": "обеспечение мира и поддержание мирового порядка",
						"score": 0
					},
					{
						"ans": "сотрудничество в области решения глобальных проблем",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let Tgp20_1_93 = {
	"name": "Tgp20_1_93",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Право на жилище",
	"data": {
		"questions": [
			{
				"qst": "Право на жилище относится к...",
				"correct_ans": [
					{
						"ans": "социально-экономическим правам и свободам личности",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "политическим правам и свободам личности",
						"score": 0
					},
					{
						"ans": "личным правам и свободам",
						"score": 0
					},
					{
						"ans": "культурным правам и свободам личности",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let Tgp20_1_28 = {
	"name": "Tgp20_1_28",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Суверенитет государства",
	"data": {
		"questions": [
			{
				"qst": "Что такое \"государственный суверенитет\"?",
				"correct_ans": [
					{
						"ans": "верховенство государственной власти внутри страны",
						"score": 3
					},
					{
						"ans": "независимость государственной власти на международной арене",
						"score": 3
					}
				],
				"wrong_ans": [
					{
						"ans": "запрещение насильственного расчленения территории или захвата и отторжения ее части",
						"score": 0
					},
					{
						"ans": "квалификация попыток насильственного расчленения территории или захвата и отторжения ее части как актов прямой агрессии",
						"score": 0
					},
					{
						"ans": "признание права государства на защиту своей территории и своих граждан, проживающих на данной территории",
						"score": 0
					},
					{
						"ans": "необходимость действия общегосударственных законов на всей территории государства",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let Tgp20_1_57 = {
	"name": "Tgp20_1_57",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Теория государства",
	"data": {
		"questions": [
			{
				"qst": "Дуалистическая монархия - это форма правления, при которой ...",
				"correct_ans": [
					{
						"comm": "При дуалистической монархии монарх осуществляет управление через подчиненное ему и ответственное перед ним правительство.",
						"ans": "монарх обладает только исполнительной властью",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"comm": "Форма правления, при которой монарх является духовной главой нации, называется теократической монархией.",
						"ans": "монарх является духовным главой нации и его власть обожествляется",
						"score": 0
					},
					{
						"comm": "Для абсолютной монархии характерно сосредоточение всей полноты власти в руках монарха.",
						"ans": "юридических ограничений полномочий монарха не существует",
						"score": 0
					},
					{
						"comm": "В парламентарных монархиях власть монарха законодательно ограничена практически во всех сферах деятельности.",
						"ans": "монарх играет представительную роль и является \"символом единства нации\"",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Форма правления, при которой у монарха остается исполнительная власть, а законодательная в принципе принадлежит парламенту - это ...",
				"correct_ans": [
					{
						"comm": "Дуалистическая монархия - это форма правления, при которой у монарха остается исполнительная власть, а законодательная принадлежит парламенту.",
						"ans": "дуалистическая монархия",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"comm": "Абсолютная монархия - сосредоточение всей полноты власти в руках монарха.",
						"ans": "абсолютная монархия",
						"score": 0
					},
					{
						"comm": "При парламентарной монархии власть монарха законодательно ограничена, законодательная власть принадлежит парламенту, а исполнительная власть осуществляется правительством.",
						"ans": "парламентарная монархия",
						"score": 0
					},
					{
						"comm": "Республика - это форма правления, при которой верховная власть осуществляется выборными органами.",
						"ans": "республика",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Дуалистическая монархия - промежуточный вариант между абсолютной и парламентарной монархиями, первоначальная форма ограниченной монархии"
}

export let Tgp20_1_42 = {
	"name": "Tgp20_1_42",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Исполнительная деятельность государственного органа",
	"data": {
		"questions": [
			{
				"qst": "Исполнительная деятельность государственных органов проявляется в том, что...",
				"correct_ans": [
					{
						"ans": "они выступают как непосредственные исполнители требований, содержащихся в актах органов государственной власти и вышестоящих органов государственного управления",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "они принимают меры и обеспечивают путем издания своих собственных актов (распоряжений) выполнение подчиненными им органами и организациями данных требований",
						"score": 0
					},
					{
						"ans": "они осуществляют свою деятельность на основе законов и во исполнение законов",
						"score": 0
					},
					{
						"ans": "они наделяются необходимой для их нормального функционирования оперативной самостоятельностью",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let Tgp20_1_80 = {
	"name": "Tgp20_1_80",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Законные интересы личности",
	"data": {
		"questions": [
			{
				"qst": "Законные интересы личности — это...",
				"correct_ans": [
					{
						"ans": "юридически значимые и юридически оправданные притязания человека на социальные блага, не охватываемые непосредственным содержанием прав и свобод граждан",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"comm": "Выбранное Вами определение относится к правовому статусу личности.",
						"ans": "законодательно установленные и взятые в единстве права, свободы и обязанности личности",
						"score": 0
					},
					{
						"comm": "Выбранное Вами определение относится к правам личности.",
						"ans": "формально-определенные, юридически гарантированные возможности пользоваться социальными благами, официальная мера возможного поведения человека в государственно-организованном обществе",
						"score": 0
					},
					{
						"comm": "Выбранное Вами определение относится к субъективным правам личности.",
						"ans": "те конкретные правомочия, которые возникают у человека как у индивидуально-определенного субъекта права на основе норм объективного права",
						"score": 0
					},
					{
						"comm": "Выбранное Вами определение относится к юридическим обязанностям личности.",
						"ans": "установленные и гарантированные государством требования к поведению человека, официальная мера должного поведения",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let Tgp20_1_91 = {
	"name": "Tgp20_1_91",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Право на труд",
	"data": {
		"questions": [
			{
				"qst": "Право на труд относится к...",
				"correct_ans": [
					{
						"ans": "социально-экономическим правам и свободам личности",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "политическим правам и свободам личности",
						"score": 0
					},
					{
						"ans": "личным правам и свободам",
						"score": 0
					},
					{
						"ans": "культурным правам и свободам личности",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let Tgp20_1_33 = {
	"name": "Tgp20_1_33",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Определение государственного аппарата",
	"data": {
		"questions": [
			{
				"qst": "Государственный аппарат представляет собой...",
				"correct_ans": [
					{
						"ans": "систему органов, с помощью которых осуществляется государственная власть, выполняются основные функции, достигаются стоящие перед государством на различных этапах его развития цели и задачи",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"comm": "Указанное Вами определение относится к политической системе общества.",
						"ans": "комплекс различных по своему характеру органов и организаций, принимающих участие в политической жизни страны и в осуществлении государственной власти",
						"score": 0
					},
					{
						"comm": "Указанное Вами определение относится к государственному механизму.",
						"ans": "совокупность различных государственных органов, организаций, вооруженных сил, материальных средств государственной власти",
						"score": 0
					},
					{
						"comm": "Указанное Вами определение относится к форме правления — части формы государства.",
						"ans": "организацию государства, включающую в себя порядок образования высших и местных государственных органов и порядок взаимоотношений между ними",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Является ли признаком государственного органа то, что он издает обязательные к исполнению правовые акты?",
				"right_ans": [
					{
						"ans": "Да",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "Нет",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let Tgp20_1_34 = {
	"name": "Tgp20_1_34",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Система органов государственного аппарата",
	"data": {
		"questions": [
			{
				"qst": "Наиболее важными частными системами современного государственного аппарата являются...",
				"correct_ans": [
					{
						"ans": "система органов государственной власти",
						"score": 2
					},
					{
						"ans": "система органов государственного управления",
						"score": 2
					},
					{
						"ans": "система судебных органов",
						"score": 1
					},
					{
						"ans": "система органов прокуратуры",
						"score": 1
					}
				],
				"wrong_ans": [
					{
						"ans": "система налоговых органов",
						"score": 0
					},
					{
						"ans": "система органов образования",
						"score": 0
					},
					{
						"ans": "система органов здравоохранения",
						"score": 0
					},
					{
						"ans": "система природоохранительных органов",
						"score": 0
					},
					{
						"ans": "система средств массовой информации",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let Tgp20_1_20 = {
	"name": "Tgp20_1_20",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Определение государства по Бодену",
	"data": {
		"questions": [
			{
				"qst": "Крупный французский мыслитель XVI столетия Жан Боден определял государство как...",
				"correct_ans": [
					{
						"ans": "правовое управление семействами и тем, что у них есть общего с верховной властью, которая должна руководствоваться вечными началами добра и справедливости. Эти начала должны давать общее благо, которое и должно составлять цель государственного устройства",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"comm": "Так определял государство один из величайших мыслителей античности Аристотель.",
						"ans": "самодовлеющее общение граждан, ни в каком другом общении не нуждающихся, и ни от кого другого не зависящих",
						"score": 0
					},
					{
						"comm": "Так определял государство Никколо Макиавелли, выдающийся мыслитель эпохи Возрождения.",
						"ans": "общее благо, которое должно получаться от выполнения реальных государственных интересов",
						"score": 0
					},
					{
						"comm": "Так определял государство известный английский философ XVI века Томас Гоббс.",
						"ans": "единое лицо, верховного владыку, суверена, воля которого вследствие договора многих лиц считается волею всех, так что оно может употреблять силы и способности каждого для общего мира и защиты",
						"score": 0
					},
					{
						"comm": "Так определял государство английский философ Джон Локк (1632-1704).",
						"ans": "общую волю, являющуюся выражением преобладающей силы, т.е. большинства граждан, входящих в государство. Государство рассматривается как совокупность людей, соединившихся в одно целое под началом ими же установленного закона",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let Tgp20_1_79 = {
	"name": "Tgp20_1_79",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Субъективные права личности",
	"data": {
		"questions": [
			{
				"qst": "Субъективные права личности — это...",
				"correct_ans": [
					{
						"ans": "те конкретные правомочия, которые возникают у человека как у индивидуально-определенного субъекта права на основе норм объективного права",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"comm": "Выбранное Вами определение относится к правовому статусу личности.",
						"ans": "законодательно установленные и взятые в единстве права, свободы и обязанности личности",
						"score": 0
					},
					{
						"comm": "Выбранное Вами определение относится к правам личности.",
						"ans": "формально-определенные, юридически гарантированные возможности пользоваться социальными благами, официальная мера возможного поведения человека в государственно-организованном обществе",
						"score": 0
					},
					{
						"comm": "Выбранное Вами определение относится к законным интересам личности.",
						"ans": "юридически значимые и юридически оправданные притязания человека на социальные блага, не охватываемые непосредственным содержанием прав и свобод граждан",
						"score": 0
					},
					{
						"comm": "Выбранное Вами определение относится к юридическим обязанностям личности.",
						"ans": "установленные и гарантированные государством требования к поведению человека, официальная мера должного поведения",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let Tgp20_1_17 = {
	"name": "Tgp20_1_17",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Различный смысл понятия государства",
	"data": {
		"questions": [
			{
				"qst": "В каких смыслах по мнению Г.Кельзена — одного из основателей теории правового нормативизма — может употребляться понятие государства?",
				"correct_ans": [
					{
						"comm": "Государство, по мнению Г. Кельзена, может рассматриваться исключительно с юридических позиций. Оно может представляться как юридическое лицо, \"правовой феномен\", как своеобразная корпорация.",
						"ans": "в юридическом смысле",
						"score": 2
					},
					{
						"comm": "В данном аспекте государство должно рассматриваться как некая \"социологическая общность\", \"социальная реальность, существующая независимо от её правового порядка и правовой реальности\".",
						"ans": "в социологическом смысле",
						"score": 2
					},
					{
						"comm": "Подобный взгляд на понятие государства разделялся многими другими авторами, в основном сторонниками так называемой органической теории государства. Достигнув апогея в своем развитии на рубеже XIX-XX вв. , данная теория пыталась объяснить всю социальную жизнь биологическими закономерностями. При этом общество полностью отождествлялось с организмом, а государство считалось \"единственным институтом, предназначенным для обеспечения благополучия всех как ныне живущих, так и ещё не родившихся граждан\".",
						"ans": "как живой, \"естественный организм\"",
						"score": 2
					},
					{
						"ans": "как \"система норм\"",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"ans": "в экономическом смысле",
						"score": 0
					},
					{
						"ans": "в культурном смысле",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Рассматривал ли Г.Кельзен государство как живой, \"естественный организм\"?",
				"right_ans": [
					{
						"ans": "Да",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"ans": "Нет",
						"score": 0
					}
				],
				"comm": "Подобный взгляд на понятие государства разделялся многими другими авторами, в основном сторонниками так называемой органической теории государства"
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Г. Кельзен заключал, что \"неудовлетворительное состояние политической теории, являющейся в основе своей теорией государства, в значительной мере предопределяется тем фактом, что исследователи государства и права нередко используют одни и те же термины в совершенно разных значениях или же рассматривают разные явления и понятия как идентичные\"",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let Tgp20_1_85 = {
	"name": "Tgp20_1_85",
	"descriprion": "type1",
	"theme": "Теория государства",
	"title": "Культурные права и свободы личности",
	"data": {
		"questions": [
			{
				"qst": "Культурные права и свободы личности — это...",
				"correct_ans": [
					{
						"ans": "возможности человека пользоваться духовными, культурными благами и достижениями, принимать участие в их создании в соответствии со своими склонностями и способностями",
						"score": 5
					}
				],
				"wrong_ans": [
					{
						"comm": "Выбранное Вами определение относится к политическим правам и свободам личности.",
						"ans": "возможности человека в государственной и общественно-политической жизни, обеспечивающие его политическое самоопределение и свободу, участие в управлении государством и обществом",
						"score": 0
					},
					{
						"comm": "Выбранное Вами определение относится к личным правам и свободам личности.",
						"ans": "возможности человека, ограждающие от незаконного и нежелательного вмешательства в его личную жизнь и внутренний мир, призванные обеспечить существование, своеобразие и автономию личности",
						"score": 0
					},
					{
						"comm": "Выбранное Вами определение относится к социально-экономическим правам и свободам личности.",
						"ans": "возможности личности в сфере производства и распределения материальных благ, призванные обеспечить удовлетворение экономических и тесно связанных с ними духовных потребностей и интересов человека",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let Tgp20_2_10 = {
	"name": "Tgp20_2_10",
	"descriprion": "type1",
	"theme": "Теория права",
	"title": "Политические и правовые нормы",
	"data": {
		"questions": [
			{
				"qst": "Какие утверждения о взаимосвязи политических и правовых норм, на Ваш взгляд, соответствуют действительности?",
				"correct_ans": [
					{
						"ans": "Политические нормы, выраженные в юридических актах государства, приобретают значение правовых норм",
						"score": 30
					},
					{
						"ans": "Политические нормы используются для оценки и обоснования правовых",
						"score": 30
					}
				],
				"wrong_ans": [
					{
						"ans": "Политические нормы определяют применимость правовых",
						"score": 0
					},
					{
						"ans": "Политические нормы применяются в тех случаях, когда общественное отношение не урегулировано правовыми нормами",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Могут ли существовать политические нормы, не являющиеся правовыми?",
				"right_ans": [
					{
						"ans": "Да",
						"score": 10
					}
				],
				"wrong_ans": [
					{
						"ans": "Нет",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let Tgp20_2_27 = {
	"name": "Tgp20_2_27",
	"descriprion": "type1",
	"theme": "Теория права",
	"title": "Инкорпорация законодательства",
	"data": {
		"questions": [
			{
				"qst": "Инкорпорация законодательства — это...",
				"correct_ans": [
					{
						"ans": "подготовка и издание различного рода собраний и сборников нормативных актов",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "деятельность по приведению нормативных актов в единую, упорядоченную систему",
						"score": 0
					},
					{
						"ans": "сбор государственными органами и другими учреждениями и организациями действующих нормативных актов, их обработка и расположение по определенной системе, хранение, а также выдача справок для заинтересованных органов, учреждений, отдельных лиц по их запросам",
						"score": 0
					},
					{
						"ans": "подготовка и принятие укрупненных актов на базе объединения норм разрозненных актов, изданных по одному вопросу",
						"score": 0
					},
					{
						"ans": "подготовка и принятие новых актов, в которых помещаются как оправдавшие себя нормы прежних актов, так и иные нормативные предписания",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let Tgp20_2_91 = {
	"name": "Tgp20_2_91",
	"descriprion": "type1",
	"theme": "Теория права",
	"title": "Следственные тормоза",
	"data": {
		"questions": [
			{
				"qst": "\"Следственные тормоза\", т.е. правоприменительный акт, незаконно и необоснованно застопоривший предварительное следствие - это...",
				"correct_ans": [
					{
						"ans": "препятствие, выражающееся в наличии конкурирующих с управлением моментов",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "фактор, не оказывающий влияние на эффективность правового воздействия",
						"score": 0
					},
					{
						"ans": "препятствие, не поддающееся воздействию (управлению)",
						"score": 0
					},
					{
						"ans": "препятствие, выражающееся в отсутствии необходимых для эффективного управления моментов",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Верно ли, что появление правоприменительных актов, незаконно и необоснованно застопоривших предварительное следствие, не оказывает влияние на эффективность правового воздействия?",
				"right_ans": [
					{
						"ans": "Нет",
						"score": 10
					}
				],
				"wrong_ans": [
					{
						"ans": "Да",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let Tgp20_2_72 = {
	"name": "Tgp20_2_72",
	"descriprion": "type1",
	"theme": "Теория права",
	"title": "Исполнение как реализация норм права",
	"data": {
		"questions": [
			{
				"qst": "Совершение субъектом права предписанных правом действий — это...",
				"correct_ans": [
					{
						"ans": "Исполнение",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Использование",
						"score": 0
					},
					{
						"ans": "Соблюдение",
						"score": 0
					},
					{
						"ans": "Применение",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let Tgp20_2_1 = {
	"name": "Tgp20_2_1",
	"descriprion": "type1",
	"theme": "Теория права",
	"title": "Конституция РФ",
	"data": {
		"questions": [
			{
				"qst": "Какое определение права и соответствующие правовые положения нашли отражение в Конституции РФ (ч. 2 ст. 17)?",
				"correct_ans": [
					{
						"comm": "Вспомните основные положения теории естественного права.",
						"ans": "Положения теории естественного права",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Вспомните основные положения теологической теории права.",
						"ans": "Положения теологической теории права",
						"score": 0
					},
					{
						"comm": "Вспомните основные положения органической теории права.",
						"ans": "Положения органической теории права",
						"score": 0
					},
					{
						"comm": "Вспомните основные положения теории насилия.",
						"ans": "Положения теории насилия",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Основана ли конструкция современного российского государства на идеях теологической теории права?",
				"right_ans": [
					{
						"ans": "Нет",
						"score": 10
					}
				],
				"wrong_ans": [
					{
						"ans": "Да",
						"score": 0
					}
				],
				"comm": "Современное российское государство является светским"
			}
		]
	},
	"minigameType": "Question"
}

export let Tgp20_2_18 = {
	"name": "Tgp20_2_18",
	"descriprion": "type1",
	"theme": "Теория права",
	"title": "Правовой обычай",
	"data": {
		"questions": [
			{
				"qst": "Правовой обычай — это...",
				"correct_ans": [
					{
						"ans": "исторически сложившееся правило поведения, которому государство придало общеобязательное значение",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Выбранное Вами определение относится к нормативно-правовому акту.",
						"ans": "властное предписание компетентного государственного органа или должностного лица, содержащее нормы права",
						"score": 0
					},
					{
						"comm": "Выбранное Вами определение относится к юридическому прецеденту.",
						"ans": "решение судебного или административного органа по конкретному делу, приобретающее общеобязательное значение",
						"score": 0
					},
					{
						"comm": "Выбранное Вами определение относится к нормативному договору.",
						"ans": "соглашение двух или более субъектов, содержащее общеобязательные правовые нормы",
						"score": 0
					},
					{
						"comm": "Выбранное Вами определение относится к правоприменительному акту.",
						"ans": "официальное властное предписание компетентного органа или должностного лица, конкретизирующее общее правоположение для индивидуального субъекта и выраженное в соответствующей форме",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let Tgp20_2_3 = {
	"name": "Tgp20_2_3",
	"descriprion": "type1",
	"theme": "Теория права",
	"title": "Теория права",
	"data": {
		"questions": [
			{
				"qst": "Социальное назначение права состоит в том, что оно...",
				"correct_ans": [
					{
						"ans": "выражает и закрепляет волю и интересы стоящих у власти классов, слоев, групп",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "является абстрактным выражением присущего данному обществу понятия справедливости",
						"score": 0
					},
					{
						"comm": "Указанная характеристика присуща не праву в целом, а только отдельным исторически преходящим его формам.",
						"ans": "освящает и закрепляет имущественное, социальное и иное неравенство людей",
						"score": 0
					},
					{
						"ans": "неотчуждаемо и принадлежит каждому от рождения",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Верно ли, что понимание права как абстрактного выражения присущего данному обществу понятия справедливости определяет его социальное назначение?",
				"right_ans": [
					{
						"ans": "Нет",
						"score": 10
					}
				],
				"wrong_ans": [
					{
						"ans": "Да",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let Tgp20_2_44 = {
	"name": "Tgp20_2_44",
	"descriprion": "type1",
	"theme": "Теория права",
	"title": "Классификация санкций",
	"data": {
		"questions": [
			{
				"qst": "Какие виды санкций правовых норм выделяются?",
				"correct_ans": [
					{
						"ans": "карательные",
						"score": 15
					},
					{
						"ans": "правовосстановительные",
						"score": 15
					}
				],
				"wrong_ans": [
					{
						"ans": "императивные",
						"score": 0
					},
					{
						"ans": "конкретные",
						"score": 0
					},
					{
						"ans": "материальные",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Верно ли, что императивные нормы права строго обязательны и не зависят от воли субъектов права?",
				"right_ans": [
					{
						"ans": "Да",
						"score": 10
					}
				],
				"wrong_ans": [
					{
						"ans": "Нет",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let Tgp20_2_66 = {
	"name": "Tgp20_2_66",
	"descriprion": "type1",
	"theme": "Теория права",
	"title": "Специфика срока как юридического факта",
	"data": {
		"questions": [
			{
				"qst": "Какие юридические факты могут выступать только как элементы фактического состава?",
				"correct_ans": [
					{
						"ans": "Сроки",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Действия",
						"score": 0
					},
					{
						"ans": "Поступки",
						"score": 0
					},
					{
						"ans": "Акты",
						"score": 0
					},
					{
						"ans": "События",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let Tgp20_2_8 = {
	"name": "Tgp20_2_8",
	"descriprion": "type1",
	"theme": "Теория права",
	"title": "Функция права",
	"data": {
		"questions": [
			{
				"qst": "Функция права - это...",
				"correct_ans": [
					{
						"ans": "направление правового воздействия на общественные отношения как реализация социального назначения права",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Для выделения функций права не требуется рассмотрение динамики его развития.",
						"ans": "изменение правовой системы в зависимости от изменения общественных отношений",
						"score": 0
					},
					{
						"ans": "специфическая деятельность отдельных органов и учреждений в правовой системе",
						"score": 0
					},
					{
						"ans": "совокупный объем полномочий правовой системы в целом в области регулирования общественных отношений",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Можно ли рассматривать функцию права как совокупный объем полномочий правовой системы в целом в области регулирования общественных отношений?",
				"right_ans": [
					{
						"ans": "Нет",
						"score": 10
					}
				],
				"wrong_ans": [
					{
						"ans": "Да",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Необходимо отметить, что как социальное назначение права, так и направление его воздействия на общественные отношения, взятые в отдельности, не исчерпывают собой понятия функции права"
}

export let Tgp20_2_53 = {
	"name": "Tgp20_2_53",
	"descriprion": "type1",
	"theme": "Теория права",
	"title": "Презумпция",
	"data": {
		"questions": [
			{
				"qst": "Положение, при котором некоторые факты считаются судом несуществующими, пока заинтересованная сторона не докажет обратное, называется...",
				"correct_ans": [
					{
						"ans": "презумпция",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "гипотеза",
						"score": 0
					},
					{
						"ans": "диспозиция",
						"score": 0
					},
					{
						"ans": "санкция",
						"score": 0
					},
					{
						"ans": "фикция",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let Tgp20_2_83 = {
	"name": "Tgp20_2_83",
	"descriprion": "type1",
	"theme": "Теория права",
	"title": "Аналогия",
	"data": {
		"questions": [
			{
				"qst": "К какому способу толкования права относится аналогия?",
				"correct_ans": [
					{
						"ans": "Логическое толкование",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Грамматическое толкование",
						"score": 0
					},
					{
						"ans": "Историческое толкование",
						"score": 0
					},
					{
						"ans": "Функциональное толкование",
						"score": 0
					}
				]
			}
		],
		"subqst": [
			{
				"qst": "Является ли аналогия разрешением случая, непосредственно не урегулированного правом, путем применения правовой нормы, регулирующей сходные по характеру отношения?",
				"right_ans": [
					{
						"ans": "Да",
						"score": 10
					}
				],
				"wrong_ans": [
					{
						"ans": "Нет",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let Tgp20_2_54 = {
	"name": "Tgp20_2_54",
	"descriprion": "type1",
	"theme": "Теория права",
	"title": "Фикция",
	"data": {
		"questions": [
			{
				"qst": "Нормативное предписание суду действовать так, как если бы какой-либо юридический факт, не имевший места в действительности, был налицо, или наоборот, как если бы действительный факт не имел места, называется...",
				"correct_ans": [
					{
						"ans": "фикция",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "гипотеза",
						"score": 0
					},
					{
						"ans": "диспозиция",
						"score": 0
					},
					{
						"ans": "санкция",
						"score": 0
					},
					{
						"ans": "презумпция",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let Tgp20_2_60 = {
	"name": "Tgp20_2_60",
	"descriprion": "type1",
	"theme": "Теория права",
	"title": "Признаки частного права",
	"data": {
		"questions": [
			{
				"qst": "Какие признаки из перечисленных характерны для частного права?",
				"correct_ans": [
					{
						"ans": "преобладание диспозитивных норм",
						"score": 12
					},
					{
						"ans": "равенство субъектов правоотношений",
						"score": 12
					},
					{
						"ans": "свободное волеизъявление субъектов при реализации своих прав",
						"score": 12
					},
					{
						"ans": "использование договорных форм регулирования",
						"score": 12
					},
					{
						"ans": "гарантированная судебная защита",
						"score": 12
					}
				],
				"wrong_ans": [
					{
						"ans": "одностороннее волеизъявление субъектов права",
						"score": 0
					},
					{
						"ans": "широкая сфера усмотрения",
						"score": 0
					},
					{
						"ans": "иерархические отношения субъектов",
						"score": 0
					},
					{
						"ans": "преобладание директивно-обязательных норм",
						"score": 0
					},
					{
						"ans": "нормативно-ориентирующее воздействие",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let Tgp20_2_28 = {
	"name": "Tgp20_2_28",
	"descriprion": "type1",
	"theme": "Теория права",
	"title": "Консолидация законодательства",
	"data": {
		"questions": [
			{
				"qst": "Консолидация законодательства — это...",
				"correct_ans": [
					{
						"ans": "подготовка и принятие укрупненных актов на базе объединения норм разрозненных актов, изданных по одному вопросу",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "деятельность по приведению нормативных актов в единую, упорядоченную систему",
						"score": 0
					},
					{
						"ans": "сбор государственными органами и другими учреждениями и организациями действующих нормативных актов, их обработка и расположение по определенной системе, хранение, а также выдача справок для заинтересованных органов, учреждений, отдельных лиц по их запросам",
						"score": 0
					},
					{
						"ans": "подготовка и издание различного рода собраний и сборников нормативных актов",
						"score": 0
					},
					{
						"ans": "подготовка и принятие новых актов, в которых помещаются как оправдавшие себя нормы прежних актов, так и иные нормативные предписания",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}